import { getCommonQuickNavPages } from "constants/quickNav/common";
import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { SETTINGS_QUICK_NAV_PAGES } from "constants/quickNav/settings";
import { QUICK_NAV_CONDITION, QuickNavPage } from "constants/quickNav/types";

const TAX_HOME_PATH = "/tax";

export const TAX_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Home", path: TAX_HOME_PATH },
  { name: "Filings", path: "/tax/filings" },
  { name: "Estimated Tax", path: "/tax/advance-tax" },
  {
    name: "Estimated Tax: Monthly Breakdown",
    path: "/tax/advance-tax/breakdown",
  },
  {
    name: "Estimated Tax: Tax benefits",
    path: "/tax/advance-tax/tax-benefits",
  },
  { name: "Estimated Tax: Settings", path: "/tax/advance-tax/settings" },
  { name: "State Compliance", path: "/tax/state-compliance" },
  { name: "R&D Tax Credits", path: "/tax/r-and-d" },
  {
    name: "Incorporation",
    path: "/tax/incorporation",
    conditions: [QUICK_NAV_CONDITION.PRE_INCORPORATE],
  },
  { name: "All Entities", path: "/tax/entities" },
  { name: "Address Book", path: "/tax/address-book" },
  ...getCommonQuickNavPages(TAX_HOME_PATH),
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES.filter(({ path }) => path !== TAX_HOME_PATH),
];
